export class PodShufflePodForecast {
  podId: number;

  podName: string;

  maxMembers: number;

  allocation: number;

  constructor(obj: any) {
    this.podId = obj.podId;
    this.podName = obj.podName;
    this.maxMembers = obj.maxMembers;
    this.allocation = obj.allocation;
  }
}

export default PodShufflePodForecast;
